import { Injectable } from '@angular/core';


/* DashboardIdentifiers should match
Mojo.Client.Core.Domain.DashboardIdentifiers
*/
@Injectable()
export class CashBalanceFieldNames {
  public static PropertyField: string = "PropertyName";
  public static SubLedgerField: string = "SubLedger";
  public static TypeField: string = "Type";
  public static BalanceField: string = "Balance";

}

export class CashBalanceFieldLabels {
  public static PropertyField: string = "Property";
  public static SubLedgerField: string = "Sub Ledger";
  public static TypeField: string = "Type";
  public static BalanceField: string = "Balance";

}
